import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Import Georgia images
import georgia1 from '../images/georgia1.jpeg';
import georgia2 from '../images/georgia2.jpeg';
import georgia3 from '../images/georgia3.jpeg';
import georgia4 from '../images/georgia4.jpeg';
import georgia5 from '../images/georgia5.jpeg';
import georgia6 from '../images/georgia6.jpeg';
import georgia7 from '../images/georgia7.jpeg';
import georgia8 from '../images/georgia8.jpeg';
import georgia9 from '../images/georgia9.jpeg';
import georgia10 from '../images/georgia10.jpeg';
import georgia11 from '../images/georgia11.jpeg';
import georgia12 from '../images/georgia12.jpeg';
import georgia13 from '../images/georgia13.jpeg';
import georgia14 from '../images/georgia14.jpeg';
import georgia15 from '../images/georgia15.jpeg';
import georgia16 from '../images/georgia16.jpeg';
import georgia17 from '../images/georgia17.jpeg';
import georgia18 from '../images/georgia18.jpeg';
import georgia19 from '../images/georgia19.jpeg';
import georgia20 from '../images/georgia20.jpeg';
import georgia21 from '../images/georgia21.jpeg';
import georgia22 from '../images/georgia22.jpeg';
import georgia23 from '../images/georgia23.jpeg';
import georgia24 from '../images/georgia24.jpeg';
import georgia25 from '../images/georgia25.jpeg';
import georgia26 from '../images/georgia26.jpeg';
import georgia27 from '../images/georgia27.jpeg';
import georgia28 from '../images/georgia28.jpeg';
import georgia29 from '../images/georgia29.jpeg';
import georgia30 from '../images/georgia30.jpeg';
import georgia31 from '../images/georgia31.jpeg';
import georgia32 from '../images/georgia32.jpeg';
import georgia33 from '../images/georgia33.jpeg';
import georgia34 from '../images/georgia34.jpeg';
import georgia35 from '../images/georgia35.jpeg';
import georgia36 from '../images/georgia36.jpeg';
import georgia37 from '../images/georgia37.jpeg';
import georgia38 from '../images/georgia38.jpeg';
import georgia39 from '../images/georgia39.jpeg';
import georgia40 from '../images/georgia40.jpeg';
import georgia41 from '../images/georgia41.jpeg';
import georgia42 from '../images/georgia42.jpeg';
import georgia43 from '../images/georgia43.jpeg';
import georgia44 from '../images/georgia44.jpeg';
import georgia45 from '../images/georgia45.jpeg';
import georgia46 from '../images/georgia46.jpeg';
import georgia47 from '../images/georgia47.jpeg';
import georgia48 from '../images/georgia48.jpeg';
import georgia49 from '../images/georgia49.jpeg';
import georgia50 from '../images/georgia50.jpeg';
import georgia51 from '../images/georgia51.jpeg';
import georgia52 from '../images/georgia52.jpeg';
import georgia53 from '../images/georgia53.jpeg';
import georgia54 from '../images/georgia54.jpeg';
import georgia55 from '../images/georgia55.jpeg';
import georgia56 from '../images/georgia56.jpeg';
import georgia57 from '../images/georgia57.jpeg';
import georgia58 from '../images/georgia58.jpeg';
import georgia59 from '../images/georgia59.jpeg';
import georgia60 from '../images/georgia60.jpeg';
import georgia61 from '../images/georgia61.jpeg';
import georgia62 from '../images/georgia62.jpeg';
import georgia63 from '../images/georgia63.jpeg';
import georgia64 from '../images/georgia64.jpeg';
import georgia65 from '../images/georgia65.jpeg';
import georgia66 from '../images/georgia66.jpeg';
import georgia67 from '../images/georgia67.jpeg';
import georgia68 from '../images/georgia68.jpeg';
import georgia69 from '../images/georgia69.jpeg';
import georgia70 from '../images/georgia70.jpeg';
import georgia71 from '../images/georgia71.jpeg';
import georgia72 from '../images/georgia72.jpeg';
import georgia73 from '../images/georgia73.jpeg';
import georgia74 from '../images/georgia74.jpeg';
import georgia75 from '../images/georgia75.jpeg';
import georgia76 from '../images/georgia76.jpeg';
import georgia77 from '../images/georgia77.jpeg';
import georgia78 from '../images/georgia78.jpeg';
import georgia79 from '../images/georgia79.jpeg';
import georgia80 from '../images/georgia80.jpeg';
import georgia81 from '../images/georgia81.jpeg';
import georgia82 from '../images/georgia82.jpeg';
import georgia83 from '../images/georgia83.jpeg';
import georgia84 from '../images/georgia84.jpeg';
import georgia85 from '../images/georgia85.jpeg';
import georgia86 from '../images/georgia86.jpeg';
import georgia87 from '../images/georgia87.jpeg';
import georgia88 from '../images/georgia88.jpeg';
import georgia89 from '../images/georgia89.jpeg';
import georgia90 from '../images/georgia90.jpeg';
import georgia91 from '../images/georgia91.jpeg';
import georgia92 from '../images/georgia92.jpeg';
import georgia93 from '../images/georgia93.jpeg';

function Georgia() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    georgia49, georgia2, georgia3, georgia4, georgia5, georgia6, georgia7, georgia8,
    georgia9, georgia10, georgia11, georgia12, georgia13, georgia14, georgia15, georgia16,
    georgia17, georgia18, georgia19, georgia20, georgia21, georgia22, georgia23, georgia24,
    georgia25, georgia26, georgia27, georgia28, georgia29, georgia30, georgia31, georgia32,
    georgia33, georgia34, georgia35, georgia36, georgia37, georgia38, georgia39, georgia40,
    georgia41, georgia42, georgia43, georgia44, georgia45, georgia46, georgia47, georgia48,
    georgia1, georgia50, georgia51, georgia52, georgia53, georgia54, georgia55, georgia56,
    georgia57, georgia58, georgia59, georgia60, georgia61, georgia62, georgia63, georgia64,
    georgia65, georgia66, georgia67, georgia68, georgia69, georgia70, georgia71, georgia72,
    georgia73, georgia74, georgia75, georgia76, georgia77, georgia78, georgia79, georgia80,
    georgia81, georgia82, georgia83, georgia84, georgia85, georgia86, georgia87, georgia88,
    georgia89, georgia90, georgia91, georgia92, georgia93
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇬🇪 Georgia 2023 🇬🇪</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Georgia ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Georgia;